import { Navigate, Outlet } from "react-router-dom";
import { isFournisseurAuthenticated } from "../utils/auth";

export default function ProtectedFournisseurRoute() {
    return isFournisseurAuthenticated() ? <Outlet /> : <Navigate to="/fournisseur/login" replace />;
}
